
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How does mobile detailing work?',
      answer:
        "We bring all our professional equipment, water, and premium products directly to your location—whether that's your home, office, or anywhere convenient. You don't need to provide anything. Just park your vehicle and we handle the rest while you go about your day."
    },
    {
      question: 'How long does a detail take?',
      answer:
        'It depends on the service and your vehicle\'s condition. Interior-only details typically take 2-3 hours, exterior details take 1.5-2 hours, and full details can take 3-5 hours. We\'ll give you an accurate time estimate when we provide your quote.'
    },
    {
      question: 'Why do you need my vehicle information for a quote?',
      answer:
        "Every vehicle is different in size, condition, and detailing needs. A compact sedan requires less time and product than a large SUV. Similarly, a lightly soiled interior is faster than one with heavy stains or pet hair. We provide accurate quotes based on your specific vehicle to ensure fair pricing and no surprises."
    },
    {
      question: 'What areas do you serve?',
      answer:
        'We serve a 30-mile radius around Miami, including areas like Miami Beach, Coral Gables, Kendall, Brickell, South Broward, Doral, and more. If you\'re not sure whether we cover your location, just text us your address and we\'ll confirm.'
    },
    {
      question: 'Do I need to be present during the detail?',
      answer:
        "No, you don't need to be present. Many of our clients schedule their detail while they're at work or running errands. As long as we have access to your vehicle and a nearby power outlet (if needed), we can complete the service without you there."
    },
    {
      question: 'What if it rains on the day of my appointment?',
      answer:
        "For exterior details, we'll need to reschedule if it's raining. However, interior details can be done in any weather. We'll always communicate with you in advance if weather might affect your appointment."
    },
    {
      question: 'What payment methods do you accept?',
      answer:
        'We accept cash, Venmo, Zelle, and all major credit cards. Payment is due after the service is completed and you\'re satisfied with the results.'
    },
    {
      question: 'Do you offer any guarantees?',
      answer:
        'Absolutely. We stand behind our work. If you\'re not completely satisfied with any aspect of the detail, let us know immediately and we\'ll make it right. Your satisfaction is our priority.'
    }
  ];

  return (
    <section className="py-20 bg-black relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-yellow-500 uppercase tracking-wider text-sm font-semibold mb-3">
            COMMON QUESTIONS
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-300">
            Everything you need to know about our mobile detailing service
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/20 rounded-xl overflow-hidden hover:border-yellow-500/40 transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer group"
              >
                <span className="text-lg font-bold text-white group-hover:text-yellow-500 transition-colors pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-yellow-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-gray-300 leading-relaxed border-t border-gray-800 pt-4">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Still Have Questions CTA */}
        <div className="mt-12 text-center">
          <div className="inline-block bg-gradient-to-br from-gray-900 to-black border-2 border-yellow-500/40 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-3">Still Have Questions?</h3>
            <p className="text-gray-300 mb-6">
              Text us anytime and we'll be happy to answer any questions you have about our services.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="sms:+17863272644"
                className="bg-yellow-500 text-black px-8 py-3.5 rounded-full font-bold hover:bg-yellow-400 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-xl shadow-yellow-500/40"
              >
                <i className="ri-message-3-line text-xl"></i>
                Text Us
              </a>
              <a
                href="https://wa.me/17863272644"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 text-white px-8 py-3.5 rounded-full font-bold hover:bg-green-500 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-xl shadow-green-600/40"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
